import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  Fade,
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  Login as LoginIcon,
} from '@mui/icons-material';
import { wolvesLabsColors } from '../../theme/wolvesLabsTheme';
import { useNavigate } from 'react-router-dom';

const QuickAccess: React.FC = () => {
  const [showAccess, setShowAccess] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const navigate = useNavigate();

  // Detectar secuencia de teclas para mostrar acceso
  useEffect(() => {
    let keySequence = '';
    const targetSequence = 'divertilandia';

    const handleKeyPress = (e: KeyboardEvent) => {
      keySequence += e.key.toLowerCase();
      
      // Mantener solo los últimos caracteres
      if (keySequence.length > targetSequence.length) {
        keySequence = keySequence.slice(-targetSequence.length);
      }

      if (keySequence === targetSequence) {
        setShowAccess(true);
        setShowSnackbar(true);
        keySequence = '';
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  const handleDirectAccess = () => {
    navigate('/divertilandia/signin');
  };

  if (!showAccess) {
    return null;
  }

  return (
    <>
      <Fade in={showAccess} timeout={500}>
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9999,
            backgroundColor: 'white',
            p: 4,
            borderRadius: 0,
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            border: `3px solid ${wolvesLabsColors.accent}`,
            textAlign: 'center',
            minWidth: 300,
          }}
        >
          <AdminIcon sx={{ fontSize: 60, color: wolvesLabsColors.primary, mb: 2 }} />
          
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: wolvesLabsColors.primary,
              mb: 2,
            }}
          >
            Acceso Rápido
          </Typography>
          
          <Typography
            variant="body2"
            sx={{
              color: wolvesLabsColors.gray[600],
              mb: 3,
            }}
          >
            Acceso directo al sistema administrativo
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<LoginIcon />}
            onClick={handleDirectAccess}
            sx={{
              backgroundColor: wolvesLabsColors.primary,
              borderRadius: 0,
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: wolvesLabsColors.accent,
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Ir a Divertilandia
          </Button>

          <Box sx={{ mt: 2 }}>
            <Button
              variant="text"
              onClick={() => setShowAccess(false)}
              sx={{
                color: wolvesLabsColors.gray[500],
                fontSize: '0.8rem',
              }}
            >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Fade>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity="success"
          sx={{ borderRadius: 0 }}
        >
          ¡Acceso administrativo activado!
        </Alert>
      </Snackbar>
    </>
  );
};

export default QuickAccess;
